import { render, staticRenderFns } from "./ManufacturingDashboard.vue?vue&type=template&id=5770169d&lang=pug&"
import script from "./ManufacturingDashboard.vue?vue&type=script&lang=js&"
export * from "./ManufacturingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports